/* eslint-disable import/no-anonymous-default-export */
import { routerRedux } from 'dva/router';
import axios from 'axios';
import {
  postLogin,
  getVerifyMFA,
  putForgotPassword,
  putResetPassword,
  postLogOut,
  postSignup
} from '../services/authentication';
import { Alert } from '../components/Alert.components';

import {
  storageToken,
  storageProfile,
  storagePrivilege,
  storageOrganisation
} from '../utils/constant';

import { asyncLocalStorage } from '../utils/utils';

const initialState = {
  profile: {},
  accessList: {},
  mfaModal: false,
  switchModal: false,
  organizations: [],
  activeOrganisation: {},
  mfaCallback: () => {}
};

export default {
  namespace: 'authentication',

  state: { ...initialState },

  subscriptions: {
    setup({ dispatch, history }) {
      // eslint-disable-line
      //Persist token details logic
      try {
        let profile = localStorage.getItem(storageProfile);
        let privilege = localStorage.getItem(storagePrivilege);
        let orgId = localStorage.getItem(storageOrganisation);

        if (profile) {
          let profileData = JSON.parse(profile);
          let accessList = JSON.parse(privilege);
          let activeOrg = profileData?.organizations?.find((item) => item._id === orgId);

          console.log({ activeOrg, orgId, profileData });

          dispatch({
            type: 'save',
            payload: {
              profile: profileData,
              organizations: profileData?.organizations,
              activeOrganisation: activeOrg,
              accessList: accessList,
            }
          });
        }
      } catch (err) {
        console.log(err);
      }
    }
  },

  effects: {
    *login({ payload }, { call, put }) {
      const { raw, success, message } = yield call(postLogin, payload);
      if (success) {
        const { userWithOtp, token } = raw;
        let accessList = {};
        accessList[userWithOtp?.userType?.description] = true;
        yield put({
          type: 'save',
          payload: {
            profile: { ...userWithOtp, token },
            organizations: userWithOtp?.organizations,
            activeOrganisation: userWithOtp?.organizations[0],
            accessList,
            mfaModal: true
          }
        });
      } else {
        Alert.error(message);
      }
    },
    *verifyMFA({ payload }, { call, put, select }) {
      const { profile, mfaCallback, accessList } = yield select(({ authentication }) => authentication);
      const { raw, success, message } = yield call(getVerifyMFA, { otp: payload, id: profile._id });
      if (success) {
        yield asyncLocalStorage.setItem(storageToken, profile?.token);
        yield asyncLocalStorage.setItem(storageOrganisation, profile?.organizations[0]?._id);
        yield asyncLocalStorage.setItem(storageProfile, JSON.stringify(profile));
        yield asyncLocalStorage.setItem(storagePrivilege, JSON.stringify(accessList))

        mfaCallback();
        yield put({
          type: 'save',
          payload: { mfaModal: false, mfaCallback: () => {} }
        });

        yield put(routerRedux.push({ pathname: '/dashboard' }));
      } else {
        Alert.error(message);
      }
    },
    *switchOrganizations({ payload }, { call, put, select }) {
       console.log({ payload })
      yield asyncLocalStorage.setItem(storageOrganisation, payload?._id);
      yield put({
        type: "save",
        payload: { activeOrganisation: payload, switchModal: false, },
      });
      window.location.reload();
    },
    *forgotPassword({ payload }, { call, put }) {
      const { raw, success, message } = yield call(putForgotPassword, payload);
      if (success) {
        Alert.success('Password reset initiated successfully. An email has been sent to your mail');
        yield put(routerRedux.push({ pathname: '/' }));
      } else {
        Alert.error(message);
      }
    },
    *resetPassword({ payload }, { call, put }) {
      const data = { token: payload.token, newPassword: payload.newPassword };
      const { raw, success, message } = yield call(putResetPassword, {
        data: data,
        userId: payload.userId
      });
      if (success) {
        Alert.success('Password reset successfully. Please proceed to login');
        yield put(routerRedux.push({ pathname: '/' }));
      } else {
        Alert.error(message);
      }
    },
    *signUp({ payload }, { call, put, select }) {
      const { raw, message, success } = yield call(postSignup, payload);
      if (success) {
        Alert.success("Company successfully created");
        yield put(routerRedux.push({ pathname: '/' }));
      } else {
        Alert.error(message);
      }
    },
    *logOut({ payload }, { call, put }) {
      // const { refresh_token } = payload;
      // call(postLogOut, { refresh_token });
      localStorage.clear();
      yield put(routerRedux.push('/'));
      yield put({ type: 'save', payload: initialState });
    }
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    }
  }
};
